import { render } from "./empty-contatos.vue?vue&type=template&id=1eab87cd&scoped=true"
import script from "./empty-contatos.vue?vue&type=script&lang=js"
export * from "./empty-contatos.vue?vue&type=script&lang=js"

import "./empty-contatos.vue?vue&type=style&index=0&id=1eab87cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eab87cd"]])

export default __exports__